<block-ui>
    <div class="d-flex flex-row-reverse">
        <div class="form-group mb-0">
            <button class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="NewUser(content)">
                <i class="fa fa-plus" aria-hidden="true"></i>
                Agregar usuario
            </button>
        </div>
    </div>
    <div class="tableFixHead mt-2">
        <table class="table table-striped mt table-sm table-hover">
            <thead style="background-color: #172749; color: white;">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Correo</th>
                    <th scope="col" class="text-center">Activo</th>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of users; let i = index" class="p-0">
                    <th scope="row">{{(i + 1)}}</th>
                    <td>{{user.Email}}</td>
                    <td class="text-center">
                        <fa-icon class="fa" icon="{{user.Active ? 'check': 'times'}}"></fa-icon>
                    </td>
                    <td class="justify-content-center option clasesita">
                        <fa-icon class="fa" icon="edit" style="cursor: pointer;" title="Editar usuario" (click)="GetUserById(user.Id, content)"></fa-icon>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</block-ui>
<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{(user && user.Id > 0)?'Editar':'Agregar'}} usuario</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <form [formGroup]="userForm" class="col">
                <div class="form-group">
                    <label>Correo electrónico</label>
                    <input type="email" class="form-control form-control-sm" aria-describedby="emailHelp" formControlName="Email">
                </div>
                <div class="form-group">
                    <label>Contraseña</label>
                    <div class="input-group form-group">
                        <input type="password" class="form-control form-control-sm" formControlName="Password" [readonly]="!checkUserPass">
                        <div class="input-group-append">
                            <div class="input-group-text">
                                <input type="checkbox" [checked]="checkUserPass" (click)="CheckUserPass()">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" formControlName="Active" style="transform: scale(1.5);">
                    <label class="form-check-label">Activo</label>
                </div>
            </form>
            <form [formGroup]="webUserCredentialForm" class="col">
                <div class="form-group">
                    <label>Usuario Registro Nacional</label>
                    <input type="email" class="form-control form-control-sm" formControlName="RegistroNacionalUser">
                </div>
                <div class="form-group">
                    <label>Contraseña Registro Nacional</label>
                    <div class="input-group form-group">
                        <input type="password" class="form-control form-control-sm" formControlName="RegistroNacionalPass" [readonly]="!checkRegistroNacionalPass">
                        <div class="input-group-append">
                            <div class="input-group-text">
                                <input type="checkbox" [checked]="checkRegistroNacionalPass" (click)="CheckRegistroNacionalPass()">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="row">
            <div class="col-sm-4 offset-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="StoreUser()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
            </div>
            <div class="col-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="CloseModal()"><i class="fa fa-times-circle" aria-hidden="true"></i> Cerrar&nbsp;</button>
            </div>
        </div>
    </div>
</ng-template>